import { render, staticRenderFns } from "./PriceQuotes.vue?vue&type=template&id=c73de064&scoped=true"
import script from "./PriceQuotes.vue?vue&type=script&lang=js"
export * from "./PriceQuotes.vue?vue&type=script&lang=js"
import style0 from "./PriceQuotes.vue?vue&type=style&index=0&id=c73de064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73de064",
  null
  
)

export default component.exports